



























import { Component, Vue } from 'vue-property-decorator';
import {Message, MessageFilter} from "@/model/message";
import {messageService} from "@/services/messages";
import MsisdnBalances from "@/components/MsisdnBalances.vue";
import MessageWithHistory from "@/components/MessageWithHistory.vue";
import MsisdnLoan from "@/components/MsisdnLoan.vue";
import TransactionsTable from "@/components/TransactionsTable.vue";
import {TransactionPreview} from "@/model/transaction-preview";
import {TransactionFilter} from "@/model/transaction-filter";
import {transactionService} from "@/services/transaction";
import FraudCaseTable from "@/components/FraudCaseTable.vue";
import {CriteriaType, FilterCriteria} from "@/model/filter-criteria";
import TransactionsCriteriaPicker from "@/components/TransactionsCriteriaPicker.vue";

@Component({
  components: {
    TransactionsCriteriaPicker,
    FraudCaseTable, TransactionsTable, MsisdnLoan, MessageWithHistory, MsisdnBalances}
})
export default class MessageView extends Vue {

  messagedId = '';
  message: Message | null = null;
  relatedMessages: Message[] = [];
  relatedTransactions: TransactionPreview[] = [];
  relatedFraudCaseIds: string[] = [];
  baseCriterias?: FilterCriteria[] | null = null

  criterias: FilterCriteria[] = []

  criteriaOptions: CriteriaType[] =  [
    CriteriaType.MSISDN,
    CriteriaType.EMAIL,
    CriteriaType.USER_ID
  ];
  overlay = true;

  async mounted() {
    this.messagedId = this.$route.params.id;
    this.message = await messageService.findById(this.messagedId);
    const criterias = [];
    if(this.message.msisdn) {
      criterias.push(new FilterCriteria(CriteriaType.MSISDN,this.message.msisdn))
    }
    if(this.message.userId) {
      criterias.push(new FilterCriteria(CriteriaType.USER_ID,this.message.userId))
    }
    if(this.message.email) {
      criterias.push(new FilterCriteria(CriteriaType.EMAIL,this.message.email))
    }
   this.baseCriterias = criterias;
  }

  updateFraudCaseIds(event: any) {
    this.relatedFraudCaseIds = event
  }

  async refreshRelated(criterias: FilterCriteria[]) {
    this.overlay = true;
    this.criterias = criterias
    console.log('Refreshed criterias',criterias);
    await this.loadRelatedMessages();
    await this.loadRelatedTransactions();
    this.overlay = false;
  }

  async loadRelatedMessages() {
    let related: Message[] = [];
    for (const c of this.criterias) {
      related = related.concat(await messageService.filter(MessageFilter.fromCriteria(c)))
    }
    related = related.filter(value => value.id !== this.message?.id);
    this.relatedMessages = [...new Map(related.map(item => [item.id, item])).values()];
  }

  async loadRelatedTransactions() {
    let related: TransactionPreview[] = [];
    for (const c of this.criterias) {
      related = related.concat(await transactionService.getAllTransactions(TransactionFilter.fromCriteria(c)))
    }
    this.relatedTransactions = [...new Map(related.map(item => [item.id, item])).values()];
  }
}
